export default "__VITE_ASSET__DDrw5_7n__"